const UIFilterNumberLocal = ({ value, decimals = 2 }) =>
  value.toLocaleString('pt-br', { style: 'decimal', maximumFractionDigits: decimals, minimumFractionDigits: decimals })

export default UIFilterNumberLocal
